import { __extends } from "tslib";
import { DDBase } from './ddbase';
var ValueObject = /** @class */ (function (_super) {
    __extends(ValueObject, _super);
    function ValueObject() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueObject.prototype.jsonObj = function () {
        return this.class2JsonObj();
    };
    /**
     * ValueObject 判断相等需要判断所有的属性都是相同
     * @param other 要比较的对象
     * @returns 是否相等
     */
    ValueObject.prototype.equals = function (other) {
        var keys = Object.keys(this);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            if (this[key] instanceof ValueObject) {
                var result = this[key].equals(other[key]);
                if (!result) {
                    return false;
                }
            }
            else if (this[key] !== other[key]) {
                return false;
            }
        }
        return true;
    };
    /**
     * ValueObject的clone就直接用当前对象的构造方法和jsonObj在基类里
     * @returns
     */
    ValueObject.prototype.clone = function () {
        var prototype = Reflect.getPrototypeOf(this);
        /* eslint-disable @typescript-eslint/ban-types */
        var newObj = Reflect.construct(prototype.constructor, [this.jsonObj()]);
        return newObj;
    };
    return ValueObject;
}(DDBase));
export { ValueObject };
